<div class="noti-wrap">
  <!-- Large screens -->
  <button *ngIf="!mobileView" type="button" class="noti-icon"
    [attr.aria-label]="'navbar.notifications.title' | translate"
    (click)="getNotifications(); notificationOP.toggle($event)">
    <i class="pi pi-bell"></i>
    <span *ngIf="notificationUnreadCount" class="noti-count">{{ notificationUnreadCount }}</span>
  </button>

  <!-- Small screens -->
  <a *ngIf="mobileView" class="noti-icon" [attr.aria-label]="'navbar.notifications.title' | translate"
    routerLink="/{{ arabicLang ? 'ar' : 'en' }}/settings/notification">
    <i class="pi pi-bell"></i>
    <span *ngIf="notificationUnreadCount" class="noti-count">{{ notificationUnreadCount }}</span>
  </a>

  <p-overlayPanel #notificationOP panelStyleClass="noti-overlay">
    <section class="noti-panel">
      <header class="noti-panel__head">
        <h3 class="noti-panel__title">{{ 'navbar.notifications.title' | translate }}</h3>
        <a class="noti-panel__all" routerLink="/{{ arabicLang ? 'ar' : 'en' }}/settings/notification"
          (click)="notificationOP.hide()">
          {{ 'navbar.notifications.seeAll' | translate }}
        </a>
      </header>

      <ul class="noti-list">
        @if (!isLoading) {
        <li *ngFor="let item of notifications" class="noti-item" [class.is-unread]="!item.isRead"
          routerLink="/{{ arabicLang ? 'ar' : 'en' }}/settings/notification" (click)="notificationOP.hide()">
          <span class="noti-item__dot" *ngIf="!item.isRead"></span>
          <div class="noti-item__body">
            <div class="noti-item__top">
              <span class="noti-item__title">{{ item.title[arabicLang ? 'ar' : 'en'] }}</span>
              <time class="noti-item__date">{{ item.createdAt! | agoOfDate }}</time>
            </div>
            <p class="noti-item__text">
              {{ item.content[arabicLang ? 'ar' : 'en'] | trimString : 40 }}
            </p>
          </div>
        </li>

        <li class="noti-empty" *ngIf="!notifications?.length">
          <i class="pi pi-bell-slash"></i>
        </li>
        } @else {
        <li class="noti-item" *ngFor="let _ of [1, 2, 3]">
          <div class="noti-item__body">
            <div class="noti-item__top">
              <p-skeleton width="110px" height="14px"></p-skeleton>
              <p-skeleton width="50px" height="12px"></p-skeleton>
            </div>
            <p-skeleton width="80%" height="12px" styleClass="mt-2"></p-skeleton>
          </div>
        </li>
        }
      </ul>
    </section>
  </p-overlayPanel>
</div>